import React, { useState, useEffect, useRef } from 'react';

const INDUSTRIES = [
  {
    key: 'spa', icon: '🌸', label: 'Spa & Wellness', color: '#a78bfa', accent: '#7c3aed',
    tagline: 'Elevate every treatment, delight every client', demoUrl: '/demo',
    features: [
      { icon: '📅', title: 'Smart Booking', desc: 'Online & walk-in scheduling with staff assignment, room management, and real-time availability' },
      { icon: '👑', title: 'VIP & Memberships', desc: 'Tiered loyalty points, VIP flags, recurring memberships — clients keep coming back' },
      { icon: '💳', title: 'Gift Cards & Packages', desc: 'Sell bundles like "5 Massage Package" or gift cards directly from your dashboard' },
      { icon: '🔔', title: 'SMS Reminders', desc: 'Automated appointment reminders sent 24hrs before — slash your no-show rate' },
      { icon: '💆', title: 'Treatment Notes', desc: 'Private staff notes per client — allergies, preferences, past treatments' },
      { icon: '💰', title: 'Commission Reports', desc: 'Track revenue and earned commissions per therapist automatically' },
    ],
    stats: [
      { label: "Today's Revenue", value: '$1,240', color: '#3ecf8e' },
      { label: 'Appointments', value: '8', color: '#a78bfa' },
      { label: 'This Month', value: '$18,400', color: '#f97316' },
      { label: 'Active Members', value: '34', color: '#f472b6' },
    ],
    rows: [
      { time: '10:00 AM', client: 'Nicole Rivera', service: 'Hot Stone Massage', staff: 'Sofia', status: 'confirmed', vip: true },
      { time: '11:30 AM', client: 'Ashley Chen', service: 'Deep Tissue 60min', staff: 'Jade', status: 'confirmed', vip: false },
      { time: '1:00 PM', client: 'Jennifer Walsh', service: 'Swedish Massage', staff: 'Sofia', status: 'pending', vip: false },
      { time: '2:30 PM', client: 'Tiffany Moore', service: 'Couples Massage', staff: 'Jade', status: 'confirmed', vip: false },
    ]
  },
  {
    key: 'auto', icon: '🔧', label: 'Auto & Motorcycle', color: '#f97316', accent: '#c2410c',
    tagline: 'From intake to invoice — run the whole shop', demoUrl: '/demo',
    features: [
      { icon: '📋', title: 'Work Orders', desc: 'Create detailed work orders with labor, parts, and status tracking from drop-off to pickup' },
      { icon: '🔩', title: 'Parts Inventory', desc: 'Track parts stock, set reorder points, and link parts directly to work orders' },
      { icon: '📱', title: 'SMS Status Updates', desc: 'Auto-text customers when their vehicle is ready — no more phone tag' },
      { icon: '🚗', title: 'Vehicle History', desc: 'Full service history per VIN — impress returning customers with what you already know' },
      { icon: '💵', title: 'Invoicing', desc: 'Professional invoices with labor + parts breakdown, sent via text or email' },
      { icon: '📊', title: 'Technician Reports', desc: 'Track hours and revenue per tech — reward your top performers' },
    ],
    stats: [
      { label: 'Open Work Orders', value: '12', color: '#f97316' },
      { label: 'Ready for Pickup', value: '3', color: '#3ecf8e' },
      { label: "Today's Revenue", value: '$2,840', color: '#f5a623' },
      { label: 'Parts in Stock', value: '248', color: '#4f8ef7' },
    ],
    rows: [
      { time: 'WO-1042', client: 'Marcus Webb', service: '2019 Harley — Oil Change + Tire', staff: 'Mike T.', status: 'in-progress', vip: false },
      { time: 'WO-1041', client: 'Dave Ruiz', service: '2021 Honda CBR — Fork Seal', staff: 'Carlos', status: 'ready', vip: true },
      { time: 'WO-1040', client: 'Sarah Kim', service: '2018 Ducati — Full Tune-Up', staff: 'Mike T.', status: 'confirmed', vip: false },
      { time: 'WO-1039', client: 'Tony Reyes', service: '2020 BMW — Chain & Sprocket', staff: 'Carlos', status: 'completed', vip: false },
    ]
  },
  {
    key: 'smoke', icon: '🌿', label: 'Smoke & Vape Shop', color: '#f5a623', accent: '#d97706',
    tagline: 'Run your counter smarter, grow your regulars', demoUrl: '/demo',
    features: [
      { icon: '📦', title: 'Inventory Management', desc: 'Track products by category — glass, vapes, CBD, tobacco — with low-stock alerts' },
      { icon: '🤝', title: 'Vendor Management', desc: 'Manage suppliers, track purchase orders, and compare pricing by vendor' },
      { icon: '👥', title: 'Customer CRM', desc: 'Build a loyal customer base with purchase history, preferences, and loyalty points' },
      { icon: '📊', title: 'Sales Pipeline', desc: 'Track leads, follow-ups, and wholesale accounts in a visual Kanban board' },
      { icon: '📱', title: 'SMS Campaigns', desc: 'Blast promos to your regulars — "New arrivals" or "Member discount weekend"' },
      { icon: '💰', title: 'Revenue Analytics', desc: 'See best-selling products, busiest hours, and top customers at a glance' },
    ],
    stats: [
      { label: "Today's Sales", value: '$890', color: '#f5a623' },
      { label: 'Items in Stock', value: '342', color: '#3ecf8e' },
      { label: 'Low Stock Alerts', value: '7', color: '#e8484a' },
      { label: 'Monthly Revenue', value: '$24,100', color: '#a78bfa' },
    ],
    rows: [
      { time: 'Glass', client: 'Bongs & Pipes', service: '48 items · 3 low stock', staff: 'GlassCo', status: 'low', vip: false },
      { time: 'Vapes', client: 'Disposables & Pods', service: '124 items · restocked today', staff: 'VapeWholesale', status: 'in-stock', vip: false },
      { time: 'CBD', client: 'Tinctures & Edibles', service: '38 items · 2 low stock', staff: 'HempDist', status: 'low', vip: false },
      { time: 'Tobacco', client: 'Cigarettes & Cigars', service: '88 items · fully stocked', staff: 'TobaccoCo', status: 'in-stock', vip: false },
    ]
  },
  {
    key: 'barber', icon: '✂️', label: 'Barbershop & Salon', color: '#c8a45e', accent: '#a07830',
    tagline: 'Fill chairs, cut no-shows, grow your clientele', demoUrl: '/demo',
    features: [
      { icon: '📅', title: 'Online Booking', desc: 'Clients book their barber and time slot from their phone — no more phone tag or walk-in chaos' },
      { icon: '💈', title: 'Chair Management', desc: 'See every barber\'s schedule at a glance. Assign walk-ins, manage breaks, track utilization' },
      { icon: '🔔', title: 'SMS Reminders', desc: 'Auto-text clients 24hrs before their cut — reduce no-shows by 40% without lifting a finger' },
      { icon: '👥', title: 'Client Profiles', desc: 'Track preferences, visit history, and spending. Know your regulars before they sit down' },
      { icon: '💰', title: 'Commission Tracking', desc: 'Automatic revenue splits per barber. Weekly payouts calculated for you' },
      { icon: '📱', title: 'SMS Promos', desc: 'Blast deals to your client list — "Tuesday Fade Special $25" fills empty chairs fast' },
    ],
    stats: [
      { label: "Today's Revenue", value: '$780', color: '#c8a45e' },
      { label: 'Appointments', value: '14', color: '#3ecf8e' },
      { label: 'This Week', value: '$4,200', color: '#f97316' },
      { label: 'Regulars', value: '86', color: '#a78bfa' },
    ],
    rows: [
      { time: '10:00 AM', client: 'Anthony Davis', service: 'Skin Fade + Beard', staff: 'Marcus', status: 'confirmed', vip: true },
      { time: '10:30 AM', client: 'Tyler Johnson', service: 'Classic Fade', staff: 'DeShawn', status: 'confirmed', vip: false },
      { time: '11:00 AM', client: 'Kevin Martinez', service: 'The Works Package', staff: 'Carlos', status: 'pending', vip: false },
      { time: '11:30 AM', client: 'Jason Wright', service: 'Kids Cut', staff: 'Jay', status: 'confirmed', vip: false },
    ]
  },
];

const STATUS_COLORS = {
  confirmed: '#3ecf8e', pending: '#f5a623', 'in-progress': '#f97316',
  ready: '#3ecf8e', completed: '#4a4a5a', 'in-stock': '#3ecf8e', low: '#e8484a'
};

function useCounter(end, duration, active) {
  const [v, setV] = useState(0);
  const done = useRef(false);
  useEffect(() => {
    if (!active || done.current) return;
    done.current = true;
    const n = parseFloat(String(end).replace(/[^0-9.]/g, ''));
    const start = Date.now();
    const tick = () => {
      const p = Math.min((Date.now() - start) / duration, 1);
      const e = 1 - Math.pow(1 - p, 3);
      setV(Math.floor(e * n));
      if (p < 1) requestAnimationFrame(tick); else setV(n);
    };
    requestAnimationFrame(tick);
  }, [active]);
  return v;
}

function MockDashboard({ industry, animKey }) {
  const [vis, setVis] = useState(false);
  useEffect(() => { setVis(false); const t = setTimeout(() => setVis(true), 60); return () => clearTimeout(t); }, [animKey]);
  const { stats, rows, color } = industry;
  return (
    <div style={{
      background: '#0a0a12', borderRadius: 18, overflow: 'hidden',
      border: `1px solid ${color}30`, boxShadow: `0 0 80px ${color}15, 0 40px 80px rgba(0,0,0,0.5)`,
      transform: vis ? 'translateY(0) scale(1)' : 'translateY(18px) scale(0.97)',
      opacity: vis ? 1 : 0, transition: 'all 0.5s cubic-bezier(0.34,1.56,0.64,1)',
    }}>
      <div style={{ background: '#1a1c2e', padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 6, borderBottom: `1px solid ${color}15` }}>
        {['#e8484a','#f5a623','#3ecf8e'].map((c,i) => <div key={i} style={{ width: 10, height: 10, borderRadius: '50%', background: c }} />)}
        <div style={{ flex: 1, textAlign: 'center', fontSize: 11, color: '#3a3a4a', fontFamily: 'monospace' }}>ivisionmarketing.com/dashboard</div>
      </div>
      <div style={{ padding: '14px 14px 18px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8, marginBottom: 14 }}>
          {stats.map((s, i) => (
            <div key={i} style={{ background: '#13131f', borderRadius: 10, padding: '10px', border: `1px solid ${s.color}15`,
              transform: vis ? 'translateY(0)' : 'translateY(10px)', opacity: vis ? 1 : 0,
              transition: `all 0.4s ease ${0.1 + i * 0.07}s` }}>
              <div style={{ fontSize: 17, fontWeight: 800, color: s.color }}>{s.value}</div>
              <div style={{ fontSize: 9, color: '#5a5a6a', marginTop: 2 }}>{s.label}</div>
            </div>
          ))}
        </div>
        <div style={{ background: '#1a1c2e', borderRadius: 10, overflow: 'hidden', border: '1px solid #1a1a2a' }}>
          <div style={{ padding: '8px 12px', borderBottom: '1px solid #1a1a2a', fontSize: 10, fontWeight: 700, color: '#4a4a5a', letterSpacing: 1, textTransform: 'uppercase' }}>
            {industry.key === 'auto' ? 'Work Orders' : industry.key === 'smoke' ? 'Inventory' : "Today's Schedule"}
          </div>
          {rows.map((r, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '9px 12px',
              borderBottom: i < rows.length - 1 ? '1px solid #1a1a2a' : 'none',
              transform: vis ? 'translateX(0)' : 'translateX(-10px)', opacity: vis ? 1 : 0,
              transition: `all 0.4s ease ${0.2 + i * 0.08}s` }}>
              <div style={{ fontSize: 9, color, fontWeight: 700, minWidth: 50, flexShrink: 0 }}>{r.time}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#e0e0f0', display: 'flex', alignItems: 'center', gap: 4 }}>
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.client}</span>
                  {r.vip && <span style={{ flexShrink: 0 }}>👑</span>}
                </div>
                <div style={{ fontSize: 9, color: '#4a4a5a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.service}</div>
              </div>
              <div style={{ fontSize: 9, color: '#3a3a4a', flexShrink: 0 }}>{r.staff}</div>
              <span style={{ fontSize: 8, fontWeight: 700, padding: '2px 6px', borderRadius: 4, flexShrink: 0,
                background: `${STATUS_COLORS[r.status] || '#4f8ef7'}18`, color: STATUS_COLORS[r.status] || '#4f8ef7' }}>
                {r.status}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function LeadForm() {
  const [form, setForm] = useState({ name: '', business: '', phone: '', type: '', message: '' });
  const [status, setStatus] = useState('idle');

  async function submit(e) {
    e.preventDefault();
    setStatus('sending');
    try {
      await fetch('https://formspree.io/f/xpwzgkwk', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(form),
      });
    } catch {}
    setStatus('done');
  }

  if (status === 'done') return (
    <div style={{ textAlign: 'center', padding: '48px 0' }}>
      <div style={{ fontSize: 52, marginBottom: 16 }}>🎉</div>
      <h3 style={{ fontFamily: "'Outfit',sans-serif", fontSize: 24, fontWeight: 800, marginBottom: 10 }}>You're on the list!</h3>
      <p style={{ color: '#6a6a7a', fontSize: 15 }}>Mike will reach out within 24 hours to set up your free demo.</p>
    </div>
  );

  const inp = {
    width: '100%', padding: '13px 16px', background: '#0a0a12', border: '1px solid #2a2a3a',
    borderRadius: 10, color: '#f0f0f2', fontSize: 14, outline: 'none', fontFamily: 'inherit',
    transition: 'border-color 0.2s',
  };
  const focus = e => e.target.style.borderColor = '#f97316';
  const blur = e => e.target.style.borderColor = '#2a2a3a';
  const lbl = { fontSize: 11, fontWeight: 700, color: '#5a5a6a', letterSpacing: 1, textTransform: 'uppercase', display: 'block', marginBottom: 6 };

  return (
    <form onSubmit={submit}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }} className="form-grid">
        <div><label style={lbl}>Your Name *</label><input required style={inp} placeholder="Your Name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} onFocus={focus} onBlur={blur} /></div>
        <div><label style={lbl}>Business Name *</label><input required style={inp} placeholder="Vegas Day Spa" value={form.business} onChange={e => setForm({...form, business: e.target.value})} onFocus={focus} onBlur={blur} /></div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }} className="form-grid">
        <div><label style={lbl}>Phone *</label><input required type="tel" style={inp} placeholder="(702) 555-0100" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} onFocus={focus} onBlur={blur} /></div>
        <div>
          <label style={lbl}>Business Type *</label>
          <select required style={{...inp, cursor: 'pointer'}} value={form.type} onChange={e => setForm({...form, type: e.target.value})} onFocus={focus} onBlur={blur}>
            <option value="">Select...</option>
            <option>Spa / Massage</option>
            <option>Auto / Motorcycle Shop</option>
            <option>Smoke / Vape Shop</option>
            <option>Barbershop / Salon</option>
            <option>Other</option>
          </select>
        </div>
      </div>
      <div style={{ marginBottom: 20 }}>
        <label style={lbl}>Anything else? (optional)</label>
        <textarea rows={2} style={{...inp, resize: 'none'}} placeholder="Current software, number of clients, questions..." value={form.message} onChange={e => setForm({...form, message: e.target.value})} onFocus={focus} onBlur={blur} />
      </div>
      <button type="submit" disabled={status === 'sending'} style={{
        width: '100%', padding: '16px', borderRadius: 12, border: 'none', cursor: status === 'sending' ? 'default' : 'pointer',
        background: status === 'sending' ? '#2a2a3a' : 'linear-gradient(135deg, #f97316, #ea580c)',
        color: '#fff', fontSize: 16, fontWeight: 700, fontFamily: 'inherit',
        transition: 'all 0.3s', boxShadow: status === 'sending' ? 'none' : '0 8px 28px rgba(249,115,22,0.4)',
      }}>
        {status === 'sending' ? 'Sending...' : '🚀 Book My Free Demo'}
      </button>
      <p style={{ textAlign: 'center', color: '#3a3a4a', fontSize: 12, marginTop: 12 }}>No spam. Mike will text or call within 24 hours.</p>
    </form>
  );
}

export default function LandingPage() {
  const [ind, setInd] = useState(0);
  const [scrolled, setScrolled] = useState(false);
  const [statsVis, setStatsVis] = useState(false);
  const statsRef = useRef(null);
  const industry = INDUSTRIES[ind];

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setStatsVis(true); }, { threshold: 0.3 });
    if (statsRef.current) obs.observe(statsRef.current);
    return () => obs.disconnect();
  }, []);

  const c1 = useCounter(40, 1800, statsVis);
  const c2 = useCounter(99, 1800, statsVis);
  const c3 = useCounter(300, 1800, statsVis);
  const c4 = useCounter(24, 1200, statsVis);

  const lbl = { color: '#f97316', fontSize: 12, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', marginBottom: 16, display: 'block' };
  const h2 = { fontFamily: "'Outfit',sans-serif", fontSize: 'clamp(30px,5vw,52px)', fontWeight: 800, letterSpacing: -2, lineHeight: 1.08 };

  return (
    <div style={{ background: '#07070f', minHeight: '100vh', color: '#f0f0f2', fontFamily: "'Outfit',system-ui,sans-serif", overflowX: 'hidden' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&display=swap');
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
        html{scroll-behavior:smooth}
        ::-webkit-scrollbar{width:4px}
        ::-webkit-scrollbar-track{background:#07070f}
        ::-webkit-scrollbar-thumb{background:#f97316;border-radius:4px}
        @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-14px)}}
        @keyframes fadeUp{from{opacity:0;transform:translateY(28px)}to{opacity:1;transform:translateY(0)}}
        @keyframes shimmer{0%{background-position:-300% 0}100%{background-position:300% 0}}
        @keyframes glow{0%,100%{opacity:.35}50%{opacity:.75}}
        @keyframes slideIn{from{opacity:0;transform:translateX(-16px)}to{opacity:1;transform:translateX(0)}}
        .nl{color:#6a6a7a;text-decoration:none;font-size:14px;font-weight:500;transition:color .2s}
        .nl:hover{color:#f0f0f2}
        .itab{cursor:pointer;padding:10px 22px;border-radius:100px;border:1px solid #1e1e2e;font-size:14px;font-weight:600;transition:all .3s;background:transparent;color:#6a6a7a;font-family:inherit}
        .itab:hover{border-color:#2e2e3e;color:#f0f0f2}
        .fc{background:#0e0e1a;border:1px solid #1a1a2a;border-radius:14px;padding:20px;transition:all .3s;cursor:default}
        .fc:hover{border-color:var(--c);transform:translateY(-4px);box-shadow:0 20px 40px rgba(0,0,0,.4)}
        .shim{background:linear-gradient(90deg,#f97316,#a78bfa,#f472b6,#f97316);background-size:300% auto;-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;animation:shimmer 4s linear infinite}
        .cb{display:inline-flex;align-items:center;justify-content:center;gap:8px;padding:14px 30px;border-radius:100px;font-size:15px;font-weight:700;cursor:pointer;border:none;transition:all .3s;text-decoration:none;font-family:inherit}
        .cbp{background:linear-gradient(135deg,#f97316,#ea580c);color:#fff;box-shadow:0 8px 24px rgba(249,115,22,.35)}
        .cbp:hover{transform:translateY(-3px);box-shadow:0 16px 40px rgba(249,115,22,.5)}
        .cbg{background:rgba(255,255,255,.04);border:1px solid #2a2a3a;color:#c0c0d0}
        .cbg:hover{background:rgba(255,255,255,.08);border-color:#3a3a4a;color:#f0f0f2}
        .crow{display:grid;grid-template-columns:2fr 1fr 1fr 1fr;align-items:center;padding:14px 20px;border-bottom:1px solid #1a1a2a;font-size:14px;transition:background .2s}
        .crow:last-child{border-bottom:none}
        .crow:hover{background:rgba(249,115,22,.04)}
        @media(max-width:900px){
          .igrid{grid-template-columns:1fr!important}
          .mock-float{animation:none!important;position:static!important}
        }
        @media(max-width:768px){
          .hctas{flex-direction:column;align-items:stretch!important}
          .fgrid{grid-template-columns:1fr 1fr!important}
          .pgrid{grid-template-columns:1fr!important}
          .crow{grid-template-columns:1fr 1fr;gap:4px}
          .crow>*:nth-child(3),.crow>*:nth-child(4){display:none}
          .hnav{display:none!important}
          .hstats{grid-template-columns:1fr 1fr!important}
          .ftinner{flex-direction:column!important;text-align:center}
          .fmgrid{grid-template-columns:1fr!important}
          section{padding:60px 20px!important}
        }
        @media(max-width:500px){
          .fgrid{grid-template-columns:1fr!important}
          .itabs{flex-direction:column}
        }
      `}</style>

      {/* NAV */}
      <nav style={{
        position:'fixed',top:0,left:0,right:0,zIndex:100,
        padding:'14px 40px',display:'flex',alignItems:'center',justifyContent:'space-between',
        background:scrolled?'rgba(7,7,15,0.94)':'transparent',
        backdropFilter:scrolled?'blur(24px)':'none',
        borderBottom:scrolled?'1px solid #1a1a2a':'none',
        transition:'all .3s',
      }}>
        <div style={{fontFamily:"'Outfit',sans-serif",fontSize:30,fontWeight:800,letterSpacing:-0.5}}>
          <span style={{color:'#f97316'}}>i</span><span style={{color:'#f0f0f2'}}>Vision</span>
        </div>
        <div className="hnav" style={{display:'flex',gap:28,alignItems:'center'}}>
          {['#industries|Industries','#features|Features','#pricing|Pricing','#demo|Get Demo','/rental|Rental'].map(s => {
            const [href, label] = s.split('|');
            return <a key={href} href={href} className="nl">{label}</a>;
          })}
          <a href="/demo" style={{
            padding:'9px 20px',background:'rgba(249,115,22,.1)',border:'1px solid rgba(249,115,22,.3)',
            borderRadius:100,color:'#f97316',textDecoration:'none',fontSize:13,fontWeight:700,transition:'all .2s',
          }}>Live Demo →</a>
          <a href="/app" style={{
            padding:'9px 20px',background:'linear-gradient(135deg,#f97316,#ea580c)',
            borderRadius:100,color:'#fff',textDecoration:'none',fontSize:13,fontWeight:700,transition:'all .3s',
            boxShadow:'0 4px 12px rgba(249,115,22,0.3)',
          }}>Sign In</a>
        </div>
      </nav>

      {/* HERO */}
      <section style={{minHeight:'100vh',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'120px 40px 80px',textAlign:'center',position:'relative',overflow:'hidden'}}>
        <div style={{position:'absolute',top:'15%',left:'-5%',width:700,height:700,borderRadius:'50%',background:'radial-gradient(circle,rgba(249,115,22,.07) 0%,transparent 65%)',pointerEvents:'none',animation:'glow 4s ease-in-out infinite'}} />
        <div style={{position:'absolute',top:'40%',right:'-8%',width:500,height:500,borderRadius:'50%',background:'radial-gradient(circle,rgba(167,139,250,.05) 0%,transparent 65%)',pointerEvents:'none',animation:'glow 5s ease-in-out infinite 1.5s'}} />

        <div style={{animation:'fadeUp .9s ease forwards',maxWidth:700,position:'relative',zIndex:1}}>
          <div style={{display:'inline-flex',alignItems:'center',gap:8,padding:'6px 18px',background:'rgba(249,115,22,.08)',border:'1px solid rgba(249,115,22,.22)',borderRadius:100,marginBottom:36}}>
            <span style={{width:6,height:6,borderRadius:'50%',background:'#3ecf8e',display:'inline-block',boxShadow:'0 0 8px #3ecf8e'}} />
            <span style={{fontSize:13,color:'#f97316',fontWeight:600}}>Built for Las Vegas businesses · Live & taking clients</span>
          </div>

          <h1 style={{fontFamily:"'Outfit',sans-serif",fontSize:'clamp(44px,8vw,96px)',fontWeight:800,lineHeight:1.02,letterSpacing:-4,marginBottom:28}}>
            The CRM that fits<br /><span className="shim">your business</span>
          </h1>

          <p style={{fontSize:19,color:'#7a7a8a',lineHeight:1.75,marginBottom:18,maxWidth:580,margin:'0 auto 18px'}}>
            Bookings, clients, SMS reminders, staff management, and revenue analytics — all in one place. Purpose-built for spas, auto shops, smoke shops, and more.
          </p>

          <div style={{fontSize:20,color:'#f0f0f2',fontWeight:700,marginBottom:44,background:'rgba(249,115,22,.08)',display:'inline-block',padding:'10px 24px',borderRadius:100,border:'1px solid rgba(249,115,22,.2)'}}>
            Handle your booking, reminders, and customer management for <span style={{color:'#f97316'}}>$99/month</span>. Your competitors pay <span style={{color:'#e8484a'}}>$300–$500</span> for the same thing.
          </div>

          <div className="hctas" style={{display:'flex',gap:14,justifyContent:'center',flexWrap:'wrap'}}>
            <a href="#demo" className="cb cbp">🚀 Book Free Demo</a>
            <a href="/demo" className="cb cbg">See It Live →</a>
          </div>
        </div>

        {/* Counter stats */}
        <div ref={statsRef} className="hstats" style={{marginTop:72,display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,maxWidth:740,width:'100%',animation:'fadeUp .9s ease .35s both'}}>
          {[
            {val:`${c1}%`,label:'Fewer no-shows with SMS reminders',color:'#3ecf8e'},
            {val:`$${c2}/mo`,label:'Starting price — founding member rate',color:'#f97316'},
            {val:`$${c3}+`,label:'What competitors charge per month',color:'#e8484a'},
            {val:`${c4}hr`,label:'Average time to go live',color:'#a78bfa'},
          ].map((s,i) => (
            <div key={i} style={{padding:'16px 12px',background:'#0e0e1a',border:`1px solid ${s.color}18`,borderRadius:14,textAlign:'center'}}>
              <div style={{fontSize:26,fontWeight:800,color:s.color,fontVariantNumeric:'tabular-nums'}}>{s.val}</div>
              <div style={{fontSize:11,color:'#5a5a6a',marginTop:5,lineHeight:1.4}}>{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* INDUSTRY SHOWCASE */}
      <section id="industries" style={{padding:'80px 40px 100px',maxWidth:1200,margin:'0 auto'}}>
        <div style={{textAlign:'center',marginBottom:48}}>
          <span style={lbl}>Built for your industry</span>
          <h2 style={h2}>One platform, every business</h2>
          <p style={{color:'#6a6a7a',fontSize:17,marginTop:14}}>Click your industry to see exactly how IVision works for you</p>
        </div>
        <div className="itabs" style={{display:'flex',gap:10,justifyContent:'center',marginBottom:52,flexWrap:'wrap'}}>
          {INDUSTRIES.map((x,i) => (
            <button key={x.key} className="itab" onClick={() => setInd(i)}
              style={ind===i?{background:`${x.color}18`,borderColor:`${x.color}55`,color:x.color}:{}}>
              {x.icon} {x.label}
            </button>
          ))}
        </div>
        <div className="igrid" style={{display:'grid',gridTemplateColumns:'1fr 1.1fr',gap:56,alignItems:'start'}}>
          <div style={{animation:'slideIn .4s ease'}} key={industry.key}>
            <div style={{marginBottom:28}}>
              <h3 style={{fontFamily:"'Outfit',sans-serif",fontSize:30,fontWeight:800,marginBottom:8}}>{industry.icon} {industry.label}</h3>
              <p style={{color:'#6a6a7a',fontSize:16,lineHeight:1.6}}>{industry.tagline}</p>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
              {industry.features.map((f,i) => (
                <div key={i} className="fc" style={{'--c':industry.color}}>
                  <div style={{fontSize:22,marginBottom:8}}>{f.icon}</div>
                  <div style={{fontSize:13,fontWeight:700,marginBottom:5,color:'#e8e8f0'}}>{f.title}</div>
                  <div style={{fontSize:12,color:'#5a5a6a',lineHeight:1.6}}>{f.desc}</div>
                </div>
              ))}
            </div>
            <div style={{marginTop:24,display:'flex',gap:12,flexWrap:'wrap'}}>
              <a href="#demo" className="cb cbp" style={{padding:'12px 24px',fontSize:14}}>Book a Demo</a>
              <a href={industry.demoUrl} target="_blank" rel="noreferrer" className="cb cbg" style={{padding:'12px 24px',fontSize:14}}>Live Demo →</a>
            </div>
          </div>
          <div className="mock-float" style={{animation:'float 5s ease-in-out infinite',position:'sticky',top:100}}>
            <MockDashboard industry={industry} animKey={ind} />
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section id="features" style={{padding:'80px 40px',background:'#0a0a12'}}>
        <div style={{maxWidth:960,margin:'0 auto'}}>
          <div style={{textAlign:'center',marginBottom:56}}>
            <span style={lbl}>Platform features</span>
            <h2 style={h2}>Everything you need,<br />nothing you don't</h2>
          </div>
          <div className="fgrid" style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:16}}>
            {[
              {icon:'📅',title:'Smart Scheduling',desc:'Calendar, walk-ins, online booking, staff assignment, and auto-confirmations'},
              {icon:'👥',title:'Client CRM',desc:'Full profiles — visit history, loyalty points, VIP status, total spend, and notes'},
              {icon:'📱',title:'SMS Campaigns',desc:'Mass promos, automated reminders, follow-ups — powered by Twilio'},
              {icon:'💰',title:'Revenue Analytics',desc:'Daily, weekly, monthly breakdowns by service, staff, and client'},
              {icon:'👩‍⚕️',title:'Staff & Commissions',desc:'Schedules, commission rates, revenue per staff member, and role permissions'},
              {icon:'🎁',title:'Gift Cards & Packages',desc:'Sell bundles and gift cards, track balances, redeem at checkout'},
              {icon:'👑',title:'Memberships',desc:'Recurring subscriptions, member pricing, automatic Stripe billing'},
              {icon:'📊',title:'Finance Dashboard',desc:'Expense tracking, profit/loss, category breakdowns, CSV export'},
              {icon:'🔔',title:'Auto Reminders',desc:'Appointment reminders cut no-shows by up to 40% — zero manual effort'},
            ].map((f,i) => (
              <div key={i} className="fc" style={{'--c':'#f97316'}}>
                <div style={{fontSize:28,marginBottom:12}}>{f.icon}</div>
                <div style={{fontSize:14,fontWeight:700,marginBottom:7,color:'#e8e8f0'}}>{f.title}</div>
                <div style={{fontSize:13,color:'#5a5a6a',lineHeight:1.7}}>{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* COMPETITOR COMPARISON */}
      <section style={{padding:'80px 20px',background:'linear-gradient(180deg,#0a0a12,#111124)',position:'relative',overflow:'hidden'}}>
        <div style={{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%,-50%)',width:600,height:600,borderRadius:'50%',background:'radial-gradient(circle,rgba(167,139,250,0.06) 0%,transparent 70%)',pointerEvents:'none'}} />
        <div style={{maxWidth:900,margin:'0 auto',position:'relative',zIndex:1}}>
          <div style={{textAlign:'center',marginBottom:48}}>
            <span style={lbl}>Compare & Save</span>
            <h2 style={h2}>Same tools. <span style={{color:'#a78bfa'}}>A fraction of the price.</span></h2>
            <p style={{color:'#94a3b8',fontSize:16,maxWidth:520,margin:'0 auto',marginTop:12}}>Everything you need to run your business — without the enterprise price tag.</p>
          </div>
          <div style={{borderRadius:16,overflow:'hidden',border:'1px solid rgba(167,139,250,0.2)',background:'rgba(15,15,30,0.8)',backdropFilter:'blur(8px)'}}>
            <div style={{display:'grid',gridTemplateColumns:'1fr 140px 140px',borderBottom:'1px solid rgba(167,139,250,0.15)',background:'rgba(167,139,250,0.06)'}}>
              <div style={{padding:'18px 24px',color:'#64748b',fontSize:13,fontWeight:600,textTransform:'uppercase',letterSpacing:0.5}}>Feature</div>
              <div style={{padding:'18px 16px',textAlign:'center'}}>
                <div style={{color:'#a78bfa',fontSize:15,fontWeight:700}}>IVision</div>
                <div style={{color:'#3ecf8e',fontSize:13,fontWeight:700,marginTop:2}}>$99/mo</div>
              </div>
              <div style={{padding:'18px 16px',textAlign:'center'}}>
                <div style={{color:'#94a3b8',fontSize:15,fontWeight:600}}>The Competition</div>
                <div style={{color:'#e8484a',fontSize:13,fontWeight:600,marginTop:2}}>$300–500/mo</div>
              </div>
            </div>
            {[
              ['Booking & scheduling',true,true],
              ['Client CRM & history',true,true],
              ['SMS reminders','Included','Add-on $'],
              ['Staff & commission tracking',true,'Some plans'],
              ['Gift cards & packages',true,'+ fees'],
              ['Website builder','Included','Extra or DIY'],
              ['Revenue analytics','Full','Basic'],
              ['Built for your industry','6 verticals','Generic'],
              ['No contracts','Month-to-month','12–24 mo lock-in'],
              ['No hidden platform fees',true,false],
            ].map(([feat,iv,them],i) => {
              const usCell = iv===true
                ? <div style={{width:26,height:26,borderRadius:'50%',background:'rgba(62,207,142,0.15)',display:'flex',alignItems:'center',justifyContent:'center',color:'#3ecf8e',fontSize:15,fontWeight:700}}>✓</div>
                : <span style={{color:'#3ecf8e',fontSize:13,fontWeight:600}}>{iv}</span>;
              const themCell = them===true
                ? <div style={{width:26,height:26,borderRadius:'50%',background:'rgba(148,163,184,0.1)',display:'flex',alignItems:'center',justifyContent:'center',color:'#64748b',fontSize:15}}>✓</div>
                : them===false
                ? <div style={{width:26,height:26,borderRadius:'50%',background:'rgba(232,72,74,0.1)',display:'flex',alignItems:'center',justifyContent:'center',color:'#e8484a',fontSize:14,fontWeight:700}}>✕</div>
                : <span style={{color:'#64748b',fontSize:13}}>{them}</span>;
              return (
                <div key={i} style={{display:'grid',gridTemplateColumns:'1fr 140px 140px',borderBottom:i<9?'1px solid rgba(100,116,139,0.12)':'none'}}
                  onMouseEnter={e=>e.currentTarget.style.background='rgba(167,139,250,0.04)'}
                  onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                  <div style={{padding:'14px 24px',color:'#e2e8f0',fontSize:14,fontWeight:500,display:'flex',alignItems:'center'}}>{feat}</div>
                  <div style={{padding:'14px 16px',display:'flex',alignItems:'center',justifyContent:'center'}}>{usCell}</div>
                  <div style={{padding:'14px 16px',display:'flex',alignItems:'center',justifyContent:'center'}}>{themCell}</div>
                </div>
              );
            })}
          </div>
          <div style={{marginTop:32,padding:'24px 32px',borderRadius:12,background:'linear-gradient(135deg,rgba(167,139,250,0.08),rgba(62,207,142,0.06))',border:'1px solid rgba(167,139,250,0.15)',display:'flex',alignItems:'center',gap:20,flexWrap:'wrap'}}>
            <div style={{fontSize:32}}>💬</div>
            <div style={{flex:1,minWidth:240}}>
              <div style={{color:'#fff',fontSize:16,fontWeight:700,marginBottom:4}}>Text the actual developer. Not a call center.</div>
              <div style={{color:'#94a3b8',fontSize:14}}>Local Las Vegas support — issues get fixed the same day.</div>
            </div>
            <a href="/signup" style={{padding:'12px 28px',borderRadius:10,background:'linear-gradient(135deg,#a78bfa,#7c3aed)',color:'#fff',fontSize:14,fontWeight:700,textDecoration:'none',whiteSpace:'nowrap'}}
              onMouseEnter={e=>{e.currentTarget.style.transform='translateY(-2px)';e.currentTarget.style.boxShadow='0 6px 20px rgba(167,139,250,0.35)';}}
              onMouseLeave={e=>{e.currentTarget.style.transform='translateY(0)';e.currentTarget.style.boxShadow='none';}}>
              Start Free →
            </a>
          </div>
        </div>
      </section>
      {/* PRICING */}
      <section id="pricing" style={{padding:'80px 40px',background:'#0a0a12'}}>
        <div style={{maxWidth:740,margin:'0 auto'}}>
          <div style={{textAlign:'center',marginBottom:56}}>
            <span style={lbl}>Simple pricing</span>
            <h2 style={h2}>Less than your coffee budget</h2>
            <p style={{color:'#6a6a7a',fontSize:17,marginTop:16}}>No setup fees. No per-transaction cuts. Cancel anytime.</p>
          </div>
          <div className="pgrid" style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:24,marginBottom:20}}>
            {[
              {name:'Founding Member',price:99,highlight:true,badge:'🔥 Limited Spots',badgeColor:'#f97316',note:'Price locked forever when you join now',
               feats:['All core features included','Booking & scheduling system','Full client CRM','SMS reminders (500/mo)','Staff & commission tracking','Revenue analytics','Gift cards & packages',['Additional locations: +$49/mo each',true],['Founding price — locked for life',true]]},
              {name:'Standard',price:199,highlight:false,badge:'Full Access',badgeColor:'#4f8ef7',note:'For businesses ready to scale',
               feats:['Everything in Founding Member','5,000 SMS messages/mo','Priority support','Custom onboarding session','Advanced reporting','API access',['Additional locations: +$49/mo each',true],['White-glove setup included',true]]},
            ].map((plan,i) => (
              <div key={i} style={{
                background:plan.highlight?'linear-gradient(160deg,#1c0d00,#0e0e1a)':'#0e0e1a',
                border:`1px solid ${plan.highlight?'#f9731635':'#1a1a2a'}`,borderRadius:24,padding:'36px 32px',position:'relative',
                boxShadow:plan.highlight?'0 0 60px rgba(249,115,22,.1)':'none',
              }}>
                {plan.highlight&&<div style={{position:'absolute',top:-13,left:'50%',transform:'translateX(-50%)',background:'linear-gradient(135deg,#f97316,#ea580c)',borderRadius:100,padding:'5px 18px',fontSize:12,fontWeight:700,color:'#fff',whiteSpace:'nowrap'}}>⭐ Most Popular</div>}
                <span style={{fontSize:11,fontWeight:700,padding:'3px 10px',borderRadius:100,background:`${plan.badgeColor}18`,color:plan.badgeColor}}>{plan.badge}</span>
                <div style={{fontSize:20,fontWeight:700,marginTop:14,marginBottom:4}}>{plan.name}</div>
                <div style={{fontSize:12,color:'#5a5a6a',marginBottom:20}}>{plan.note}</div>
                <div style={{display:'flex',alignItems:'baseline',gap:4,marginBottom:28}}>
                  <span style={{fontSize:58,fontWeight:800,fontFamily:"'Outfit',sans-serif",letterSpacing:-3,color:plan.highlight?'#f97316':'#f0f0f2'}}>${plan.price}</span>
                  <span style={{color:'#5a5a6a',fontSize:15}}>/month</span>
                </div>
                <div style={{display:'flex',flexDirection:'column',gap:11,marginBottom:32}}>
                  {plan.feats.map((f,j) => {
                    const hi = Array.isArray(f); const txt = hi?f[0]:f;
                    return <div key={j} style={{display:'flex',alignItems:'flex-start',gap:10,fontSize:14}}>
                      <span style={{color:plan.highlight?'#f97316':'#3ecf8e',flexShrink:0,marginTop:1}}>✓</span>
                      <span style={{color:hi?'#f97316':'#b0b0c0',fontWeight:hi?700:400}}>{txt}</span>
                    </div>;
                  })}
                </div>
                <a href="#demo" className={`cb ${plan.highlight?'cbp':'cbg'}`} style={{width:'100%',display:'flex',textDecoration:'none',justifyContent:'center'}}>
                  {plan.highlight?'🚀 Claim Your Spot':'Get Started'}
                </a>
              </div>
            ))}
          </div>
          <div style={{background:'#0e0e1a',border:'1px solid #1a1a2a',borderRadius:14,padding:'18px 24px',display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:10}}>
            <div style={{fontSize:14,color:'#7a7a8a'}}>📱 <strong style={{color:'#f0f0f2'}}>SMS add-ons:</strong> 500 texts — $29 &nbsp;·&nbsp; 2,000 texts — $49 &nbsp;·&nbsp; 5,000 texts — $79/mo &nbsp;·&nbsp; <strong style={{color:'#f0f0f2'}}>Extra locations:</strong> +$49/mo each</div>
            <div style={{fontSize:12,color:'#4a4a5a'}}>Billed monthly · Cancel anytime</div>
          </div>
        </div>
      </section>

      {/* DEMO FORM */}
      <section id="demo" style={{padding:'80px 40px'}}>
        <div style={{maxWidth:620,margin:'0 auto'}}>
          <div style={{textAlign:'center',marginBottom:48}}>
            <span style={lbl}>Get started today</span>
            <h2 style={h2}>Book your free demo</h2>
            <p style={{color:'#6a6a7a',fontSize:17,marginTop:14}}>We'll set up a live walkthrough for your business. If you like it, your account can be live the same day.</p>
          </div>
          <div style={{background:'#0e0e1a',border:'1px solid #1a1a2a',borderRadius:24,padding:'40px',boxShadow:'0 0 80px rgba(249,115,22,.07)'}}>
            <div style={{display:'flex',alignItems:'center',gap:16,marginBottom:32,paddingBottom:28,borderBottom:'1px solid #1a1a2a'}}>
              <div style={{width:52,height:52,borderRadius:'50%',background:'linear-gradient(135deg,#f97316,#ea580c)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:22,flexShrink:0}}>👋</div>
              <div>
                <div style={{fontSize:16,fontWeight:700}}>Mike — IVision Marketing LLC</div>
                <div style={{fontSize:13,color:'#6a6a7a'}}>Las Vegas, NV · ivanjackm@protonmail.com · Responds within 24 hours</div>
              </div>
            </div>
            <LeadForm />
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{padding:'36px 40px',borderTop:'1px solid #1a1a2a'}}>
        <div className="ftinner" style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:16}}>
          <div style={{fontFamily:"'Outfit',sans-serif",fontSize:20,fontWeight:800}}>
            <span style={{color:'#f97316'}}>i</span><span>Vision</span>
            <span style={{fontSize:11,color:'#3a3a4a',fontFamily:'Outfit',fontWeight:400,marginLeft:10}}>Marketing LLC</span>
          </div>
          <div style={{color:'#3a3a4a',fontSize:13}}>© 2026 IVision Marketing LLC · Las Vegas, NV</div>
          <div style={{display:'flex',gap:24}}>
            {['#industries|Industries','#pricing|Pricing','#demo|Get Demo'].map(s => {
              const [href,label] = s.split('|');
              return <a key={href} href={href} className="nl" style={{fontSize:13}}>{label}</a>;
            })}
          </div>
        </div>
      </footer>
    </div>
  );
}
